import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";



import log1 from "../../assets/Images/Logo/clear1.jpg";
import log2 from "../../assets/Images/Logo/clear2.jpg";
import log3 from "../../assets/Images/Logo/1.png";
import log4 from "../../assets/Images/Logo/1.5.jpg";
import log5 from "../../assets/Images/Logo/2.png";
import log6 from "../../assets/Images/Logo/3.png";
import log7 from "../../assets/Images/Logo/4.png";
import log8 from "../../assets/Images/Logo/5.png";
import log9 from "../../assets/Images/Logo/6.png";

import cp1 from "../../assets/Images/cposter/1.png";
import cp2 from "../../assets/Images/cposter/2.png";
import cp3 from "../../assets/Images/cposter/3.png";


import ap1 from "../../assets/Images/pixelobs.jpg";
import ap2 from "../../assets/Images/catposter.png";
import ap3 from "../../assets/Images/posters/postervp.png";
import ap4 from "../../assets/Images/posters/3dposter.png";
import ap5 from "../../assets/Images/3dpot/3dcat.jpg";


import dm1 from "../../assets/Images/progress/3d2.png";
import dm2 from "../../assets/Images/progress/3d3.png";
import dm3 from "../../assets/Images/progress/catprog1.png";
import dm4 from "../../assets/Images/progress/catprog2.png";
import dm5 from "../../assets/Images/progress/5.png";



import fi1 from "../../assets/Images/3dpot/3dcat.jpg";
import fi2 from "../../assets/Images/fieldpics/field3.JPG";

import fac1 from "../../assets/Images/face/3d5.png";
import fac2 from "../../assets/Images/face/face_after_shade.png";
import fac3 from "../../assets/Images/progress/vanhome.png";


























import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";





const Lo3Reason = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];
    const images2 = [log1,log2,log3,log4,log5,log6,log7,log8,log9]
    const images3 = [cp1,cp2,cp3]
    const images4 = [ap1,ap2,ap3,ap4,ap5]
    const images5 = [dm1,dm2,dm3,dm4,dm5]
    const images6 = [fi1,fi2]
    const images7 = [fac1,fac2,fac3]






    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo3-headings">
                <h1>Iteration</h1>
                <p>I should explain why I changed things, what change, and test if the changes is for the better.</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
            </div>

            <div className="content-lo3">
                <div className="content-lo3-reason">
                    <div className="content-lo3-reason-text">
                        <h1>Iteration for the Group Logo</h1>
                        <p>
                            The group logo started from a shared concept: an octopus and a light, symbolizing adaptability and guidance. Each group member created their own version of the logo,
                            and we held a vote to decide which direction to pursue further. I took one of the selected ideas and began translating it into a digital format using Adobe Illustrator,
                            turning the sketch into a clean vector design.
                        </p>
                        <h2>Feedback and Design Revisions</h2>
                        <p>
                            After presenting the initial digital version, I received feedback from both peers and instructors. One notable conversation was with Chris, who suggested making the design
                            more dynamic and expressive. He encouraged us to use the tentacles to hold or interact with something meaningful—an object that connects to our studio's identity.
                        </p>
                        <h2>Key Changes Based on Feedback</h2>
                        <p>
                            To improve the design based on the feedback, I made several specific changes:
                            <ul>
                                <li>Made the octopus grab a light - reinforcing the idea that we, as a studio, guide our clients through creativity and clarity.</li>
                                <li>Added circular elements around the tentacles - this made the design feel more dynamic and gave the octopus more motion and character.</li>
                                <li>Refined the tentacle positioning and flow - making them feel more natural and visually balanced.</li>

                            </ul>
                        </p>
                        <h2>Final Direction</h2>
                        <p>
                            Although I iterated through multiple versions, one of my groupmates, Sam, eventually created a cleaner and more refined design that resonated with everyone. We all agreed to use
                            his version as the final Octolume logo. Still, my contributions and iterations played a key role in shaping the creative direction and helped influence the final outcome.
                        </p>
                        
                    </div>

                    <div className="content-lo3-reason-text2">
                        <h1>Iteration on the Concept Posters for the client</h1>
                        <p>
                            To start the creative process for our concept poster, each group member including Tommy, Sem, and myself created their own poster drafts. When we finished our versions, we showed
                            them to one of our teachers, Lody, for feedback. He recommended that instead of selecting a single design, we combine the best features from each to create an efficient more valuable version.
                            This advice pushed us in a new direction. We went back through our drafts, examined the strongest components of each (such as layout, color use, photography, and typography), and then started
                            working on a new version that included Lody's recommendation.
                        </p>
                        <h2>Combining Ideas into One Iteration</h2>
                        <p>
                            Using Figma, we worked in real time to combine components from each design into a unified poster. We kept iterating, changing the layout structure, fonts, and how the primary message was visually
                            communicated. Our goal was to design a version that met our client's campaign.
                        </p>
                        
                    </div>

                    <div className="content-lo3-reason-text3">
                        <h1>Iteration on the Actual Poster product</h1>
                        <p>
                            After completing the first version of my poster for the Virtual Production campaign, I shared it a few students from my semester to gather feedback. Overall, the reactions were positive 
                            many said that the cat element really stood out and immediately caught their attention, which was exactly what I intended with our cat meme theme.
                            However, while the poster grabbed attention visually, a few students pointed out that it was still lacking clear information about what Virtual
                            Production actually is. This was useful feedback that helped me realize I needed to improve the balance between visual appeal and informative content.


                        </p>
                        <h2>Teacher Feedback and a New Idea</h2>
                        <p>
                            While getting feedback, Adib and I were also given a feedback. He appreciated the humor and bold visuals but suggested we could take the campaign a step further by making it interactive.
                            He mentioned that we could try using arduino to make our poster more interactive, with the arduuino we could play a cat sounds whenever somone walked by the poster.
                        </p>
                        
                        
                    </div>

                    <div className="content-lo3-reason-text4">
                        <h1>Iteration on the 3D Mascot</h1>
                        <h2>From Concept to Action</h2>
                        <p>
                            Originally, my groupmate Adib used a placeholder 3D cat to test it with a poster. But during an assessment, I received feedback to create our own product Instead of using someone else assets. This feedback also motivated me
                            to fully commit to building the 3D mascot myself, based on our sketch and campaign theme.



                        </p>
                        <h2>Building the 3D Mascot in Blender</h2>
                        <p>
                            With the sketch and concept ready, I began modeling the character in Blender for the first time. It was challenging, especially starting from scratch, but I used our 2D drawings as a reference and followed tutorials to understand
                            the process. I carefully matched the proportions and style to reflect the low poly look I had planned earlier.
                        </p>
                        <h2>Teacher Support and Skill Growth</h2>
                        <p>
                            While working on the model, I got support from my teacher Chris, who guided me through Blender's tools and shortcuts. He also taught me how to use image references behind the model, which helped me model the mascot accurately to scale.
                            His help gave me more confidence to move from a rough model to a more polished version.
                        </p>
                        
                        
                    </div>

                    <div className="content-lo3-reason-text5">
                        <h1>Combining Mascot with Poster</h1>
                        <h2>Replacing the Previous Model with Our Own Product</h2>
                        <p>
                            In the early stages, we created a 3D cat placeholder to test the poster design. However, after obtaining feedback during our assessment, I was inspired to design our own personalized mascot that better reflects the campaign.
                            This made the product feel more unique, personal, and aligned with our creative vision.
                        </p>
                        <h2>Merging Design and Character</h2>
                        <p>
                            When the mascot was finished, I combined it with the final poster design to offer a more immersive experience. Rather than keeping them separate, the mascot was put alongside the poster to strengthen the visual and thematic
                            connection between the two pieces.
                        </p>
                        <h2>Making it Interactive with Arduino</h2>
                        <p>
                            I worked with Adib to add an Arduino, ultrasonic sensor, and speaker to the product. When someone goes by, the sensor detects motion and emits a cat sound, making the product enjoyable, unexpected, and eye-catching.
                        </p>
                        <h2>Why this works?</h2>
                        <p>
                            Changing from a test model to a personal mascot and combining it with interactive electronics transformed our poster into a completely interactive display. It no longer just communicated visually it makes people to react,
                            smile and remember the message behind our campaign.
                        </p>
                    </div>

                    <div className="content-lo3-reason-text6">
                        <h1>Iteration on The 3D Facemodel</h1>
                        <h2>Optimizing the Model with Feedback from Josh</h2>
                        <p>
                            After importing the LiDAR scan into Blender, Josh informed me that the model was too heavy and could cause problems with performance. He told me to use Blender's Decimate module to reduce the number of polygons and make the model
                            lighter. This improved the responsiveness and loading speed, which is very crucial when integrating it into a website.
                        </p>
                        <h2>Sculpting for Interaction</h2>
                        <p>
                            Once optimized, I started sculpting the 3D face to separate the eyes so I could try to make the eyes interact with user's cursor(still on progress).
                        </p>
                        <h2>Making it Less Uncanny</h2>
                        <p>
                            After showing an early version to Jan, I received feedback that the model looked a bit too realistic and uncanny, which could be uncomfortable for viewers. Based on that, I decided to lean into a more stylized, sculpture-like look rather than full realism.
                        </p>
                        <h2>Playing with Shading Styles</h2>
                        <p>
                            To reduce realism, I experimented with Blender's shading options, focusing on flat and stylized materials. This helped me achieve a look that felt more artistic and matched the creative tone of the website.

                        </p>
                        <h2>Learning About Ambient Occlussion</h2>
                        <p>
                            Chris gave helpful feedback about lighting and suggested I explore ambient occlusion to improve the depth and shading of the model. This made the overall look feel more natural and helped bring out subtle features without making the model feel too lifelike.
                        </p>
                        <h2>Placing the Model on the Homepage</h2>
                        <p>
                            With the model optimized and styled, I integrated it into the homepage using React Three Fiber. Even though the eye-tracking interaction is still in progress, the 3D face already gives the homepage a unique, personal, and creative identity that reflects my approach to design.
                        </p>
                        
                    </div>


                    <div className="content-lo3-reason-slideshow">
                        <Slideshow images={images2} />

                    </div>

                    <div className="content-lo3-reason-slideshow2">
                        <Slideshow images={images3} />

                    </div>

                    <div className="content-lo3-reason-slideshow3">
                        <Slideshow images={images4} />

                    </div>

                    <div className="content-lo3-reason-slideshow4">
                        <Slideshow images={images5} />

                    </div>

                    <div className="content-lo3-reason-slideshow5">
                        <Slideshow images={images6} />

                    </div>

                    <div className="content-lo3-reason-slideshow6">
                        <Slideshow images={images7} />

                    </div>


                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo3Reason;